<template>
  <div class="login-page">
    <b-container fluid class="split-shell">
      <b-row class="split-row no-gutters">
        <b-col cols="12" lg="7" class="left-pane">
          <section class="brand-panel">
            <p class="brand-kicker">Willkommen bei</p>
            <h1 class="brand-title">
              <span class="brand-highlight">E. Richter</span>
              Sicherheitstechnik
            </h1>
            <p class="brand-subtitle">IAMS Mitarbeiter Portal Login</p>
          </section>
        </b-col>
        <b-col cols="12" lg="5" class="right-pane">
          <section class="login-card">
            <p class="login-kicker">IAMS Login</p>
            <h2 class="login-title">Anmelden</h2>

            <div class="field-group">
              <label class="field-label" for="username">Benutzername</label>
              <b-input
                id="username"
                class="login-input"
                @keyup.enter="$refs.password.focus()"
                v-model="username"
                autocomplete="username"
                placeholder="Benutzername"
              ></b-input>
            </div>

            <div class="field-group">
              <label class="field-label" for="password">Passwort</label>
              <b-input
                id="password"
                ref="password"
                class="login-input"
                @keyup.enter="login()"
                v-model="password"
                type="password"
                autocomplete="current-password"
                placeholder="Passwort"
              ></b-input>
            </div>

            <b-button class="login-btn" variant="primary" block @click="login()">
              Anmelden
            </b-button>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "UserLogin",
  data: function () {
    return {
      user: this.$user,
      username: "",
      password: "",
    };
  },
  methods: {
    login: function () {
      this.$root.apiRequest(
        "/login",
        {
          username: this.username,
          password: this.password,
        },
        (response) => {
          var now = new Date();
          now.setDate(now.getDate() + 7);

          document.cookie =
            "session=" +
            response.data.result.sessionId +
            "; Path=/; Expires=" +
            now.toUTCString() +
            ";";
          this.user.id = response.data.result.id;
          this.user.username = response.data.result.username;
          this.user.admin = response.data.result.admin;
        }
      );
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f3f6fa 0%, #e7eef6 100%);
}

.split-shell {
  min-height: 100vh;
  padding: 0;
}

.split-row {
  min-height: 100vh;
}

.left-pane {
  background: linear-gradient(140deg, #1c2736 0%, #24364f 60%, #2c4567 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
}

.brand-panel {
  max-width: 680px;
}

.brand-kicker {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #c5d2e6;
}

.brand-title {
  margin: 0;
  font-size: clamp(2rem, 5vw, 4.3rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
}

.brand-highlight {
  color: #ffec3c;
  text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.28);
}

.brand-subtitle {
  margin: 1rem 0 0;
  font-size: clamp(1.05rem, 2vw, 1.5rem);
  color: #e4ebf8;
}

.right-pane {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.login-card {
  width: 100%;
  max-width: 420px;
  padding: 1.5rem 0.25rem;
}

.login-kicker {
  margin: 0;
  font-size: 0.78rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #596f8a;
  font-weight: 600;
}

.login-title {
  margin: 0.25rem 0 1.3rem;
  font-size: 1.9rem;
  line-height: 1.15;
  color: #22384f;
  font-weight: 700;
}

.field-group {
  margin-bottom: 1rem;
}

.field-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #3f566c;
}

.login-input :deep(.form-control) {
  border-radius: 0;
  border: 1px solid #b6c6d8;
  background: #fff;
  min-height: 42px;
}

.login-input :deep(.form-control:focus) {
  border-color: #2368c4;
  box-shadow: 0 0 0 1px #2368c4;
}

.login-btn {
  margin-top: 0.4rem;
  min-height: 42px;
  font-weight: 600;
  border-radius: 0;
  background: #0f6cbd;
  border-color: #0f6cbd;
}

.login-btn:hover,
.login-btn:focus {
  background: #115ea3;
  border-color: #115ea3;
}

@media (max-width: 991px) {
  .left-pane {
    min-height: 44vh;
  }

  .right-pane {
    min-height: 56vh;
  }
}

@media (min-width: 992px) {
  .login-card {
    padding: 2rem 0.5rem;
  }
}

@media (max-width: 575px) {
  .brand-kicker {
    font-size: 0.8rem;
  }

  .login-card {
    padding: 1.2rem 0;
  }
}
</style>
